<div class="container mt-5 text-center check-out-container">
  <h1 class="mt-5 pt-5">Köszönjük megrendelésedet!</h1>
  <p class="pb-5 mb-5">Megrendelésedet fogadtuk, és elküldésének tényét visszaigazoltuk az általad megadott e-mail címre. A visszaigazoló e-mail tartalmazza az általad megadott adatokat és a megrendelt áruk felsorolását. A visszaigazolás a megrendelés elküldését igazolja.</p>
  <h2>SimplePay tranzakció azonosító: <b>{{transactionId}}</b></h2>
  <h2>Rendelés azonosító: <b>{{orderId}}</b></h2>
</div>
